<div class="welcome-page">
  <main class="welcome-main">
    <div class="welcome-container">
      <div class="welcome-layout">
        <!-- Основная колонка -->
        <div class="welcome-feed-column">
          <app-activity-events></app-activity-events>
        </div>

        <!-- Правый сайдбар -->
        <aside class="welcome-sidebar">
          <div class="welcome-side-card">

            <a class="welcome-quick-action welcome-quick-action--rules" href="assets/doc/communication_rules.pdf"
              target="_blank">
              <span class="welcome-quick-action-icon welcome-quick-action-icon--rules">
                <i class="fas fa-flag"></i>
              </span>
              <div class="welcome-quick-action-text">
                <div class="welcome-quick-action-title">Правила общения на портале</div>
                <div class="welcome-quick-action-subtitle">Тон, модерация, эскалация</div>
              </div>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round">
                <path d="M9 6l6 6-6 6"></path>
              </svg>
            </a>
          </div>

          <!-- Чемпионы -->
          @if (userContextSvc?.currentUser?.SelectedBF?.IsVisibleRating) {
          <div class="welcome-side-card">
            <div class="welcome-panel-header">
              <h3 class="welcome-panel-title">Чемпионы</h3>
              <div style="flex: 1"></div>
              <button type="button" class="welcome-link-btn" routerLink="/rating/">
                Все →
              </button>
            </div>
            <div class="welcome-champions-list">
              @for (userRating of rating; track userRating; let i = $index) {
              <div class="welcome-champion-item">
                <div class="welcome-champion-avatar-wrapper">
                  <div class="welcome-champion-avatar" [style.background]="
                          championPhotoUrl(userRating) ? 'transparent' : ''
                        ">
                    @if (championPhotoUrl(userRating); as url) {
                    <img [src]="url" class="welcome-champion-avatar-img" alt="" loading="lazy" />
                    }
                    @if (!championPhotoUrl(userRating)) {
                    <!-- <i class="fas fa-user-tie"></i> -->
                    <ui-avatar [fullName]="userRating.User.Title" size="m"></ui-avatar>
                    }
                  </div>
                  <div class="welcome-champion-rank" [ngClass]="'rank-' + getChampionTrophyClass(i)">
                    {{ i + 1 }}
                  </div>
                </div>
                <div class="welcome-champion-info">
                  <div class="welcome-champion-name">{{ userRating.User.Title }}</div>
                  <div class="welcome-champion-role">{{ userRating.User.JobTitle }}</div>
                </div>
                <div class="welcome-champion-score">
                  <div class="welcome-champion-score-value">{{ userRating.Score || 0 }}</div>
                  <div class="welcome-champion-score-label">баллов</div>
                </div>
              </div>
              }
            </div>
          </div>
          }

          <div class="welcome-side-card">
            <div class="welcome-panel-header">
              <h3 class="welcome-panel-title">Статистика идей</h3>
              <div style="flex: 1"></div>
              <span class="welcome-panel-total">
                Всего <b>{{ groupingStatRows | groupingStatTotal }}</b>
              </span>
            </div>
            <div class="welcome-stats-grid">
              @for (row of groupingStatRows; track row) {
              <div class="welcome-stat-card" [class.welcome-stat-card--clickable]="row.GroupingCategoryId > 0"
                (click)="selectGroupingRow(row)" [attr.role]="row.GroupingCategoryId > 0 ? 'button' : null"
                [attr.tabindex]="row.GroupingCategoryId > 0 ? 0 : null" (keydown.enter)="selectGroupingRow(row)"
                (keydown.space)="$event.preventDefault(); selectGroupingRow(row)">
                <div class="d-flex align-items-center gap-3 mb-2">
                  <div class="welcome-stat-icon" [style.background-color]="row.displayColor || null">
                    <i [class]="getGroupingStatIconClass(row)" aria-hidden="true"></i>
                  </div>
                  <div class="welcome-stat-value">{{ row.Count || 0 }}</div>
                </div>
                <div class="welcome-stat-label">{{ row.Title }}</div>
              </div>
              }
            </div>
          </div>

          <div class="welcome-side-card">
            <div class="welcome-panel-header">
              <h3 class="welcome-panel-title">Идеи по месяцам</h3>
            </div>
            <div class="welcome-month-chart-placeholder">
              @if (monthChartOption) {
              <div class="welcome-month-chart-host" [autoResize]="true" echarts [options]="monthChartOption" aria-label="Идеи по месяцам">
              </div>
              }
              @if (!monthChartOption && !loading) {
              <p class="welcome-chart-empty">Нет данных для графика</p>
              }
            </div>
          </div>
        </aside>
      </div>
    </div>
  </main>

  <app-loading-ui-blocker [loading]="loading" />
</div>